export const DEFAULT_THUMBNAIL_CAROUSEL_SETTINGS = {
  nav: false,
  gutter: 1,
  speed: 300,
  loop: false,
  mouseDrag: true,
  autoWidth: true,
  controls: false,
  rewind: true,
};
